import { useMemo, useRef } from 'react';
import { DefaultChatTransport } from 'ai';

import { useSelectedCycle } from 'utils/hooks/globalState/useSelectedCycle';

import { useAiCompanionSidebarInternal } from '../AiCompanionSidebarContext';
import { companionFetch, companionUrl } from '../utils/companionRequest';

export const useCompanionTransport = () => {
  const { mode, currentUrl } = useAiCompanionSidebarInternal();
  const cycle = useSelectedCycle();

  // read at send time, so a navigation mid-thread still ships the page the user is on
  const contextRef = useRef({ mode, url: currentUrl, cycle });
  contextRef.current = { mode, url: currentUrl, cycle };

  return useMemo(
    () =>
      new DefaultChatTransport({
        api: companionUrl('/api/chat'),
        fetch: companionFetch,
        prepareSendMessagesRequest: ({ id, messages: turns, body }) => ({
          body: {
            id,
            // the agent stored earlier turns' files; resending them re-uploads every one each turn
            messages: turns.map((turn, index) =>
              index === turns.length - 1
                ? turn
                : {
                    ...turn,
                    parts: turn.parts.filter(part => part.type !== 'file'),
                  }
            ),
            context:
              contextRef.current.mode === 'sidebar'
                ? contextRef.current
                : {
                    mode: contextRef.current.mode,
                    cycle: contextRef.current.cycle,
                  },
            ...body,
          },
        }),
      }),
    []
  );
};
